import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { SessionQuery } from '@core/session/store/session.query';
import { NzMessageService } from 'ng-zorro-antd/message';
import { filter, map } from 'rxjs/operators';

export const analyticsModuleAccessGuard: CanActivateFn = (route, state) => {
  const session = inject(SessionQuery);
  const nzMessageService = inject(NzMessageService);

  return session.user$.pipe(
    filter((o) => o !== null),
    map((o) => {
      if (session.hasClaim('modules:analytics:access', false)) {
        return true;
      }

      nzMessageService.warning('У вас нет прав доступа к модулю аналитики');
      return false;
    }),
  );
};
